import React, { useContext, useEffect, useState } from 'react';
import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import axiosInstance from '../../../config/axios';
import { RootContext } from '../../../App';
import refactorStructureData from '../../../helpers/refactorDataMenu';
import { Button } from "@material-tailwind/react";
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2';
import Input from "@material-tailwind/react/Input";
import { Textarea } from "@material-tailwind/react";

const EditPromo = () => {

    const { state, setState } = useContext(RootContext);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState(null);
    const [description, setDescription] = useState(null);
    const history = useHistory();
    const [file, setFile] = useState(null);
    const [listData, setListData] = useState([]);
    const param = useParams();

    const group = JSON.parse(localStorage.getItem("group"));

    const submitHandle = (event) => {

        setLoading(true);
        const token = localStorage.getItem("access_token");

        const formData = new FormData();
        formData.append('token', token);
        formData.append('group', group.wbid);
        formData.append('id', param.id);
        formData.append('title', title);
        formData.append('description', description);
        formData.append('gambar', file);

        axiosInstance.post('v2/update_promo', formData, {

            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {

            if (res.data.code === 0) {

                Swal.fire(
                    'Saved!',
                    'Your data is saved!',
                    'success'
                ).then(() => {

                    history.push("/web_management/cms/promo");

                });
            } else {

                Swal.fire(
                    'Failed!',
                    'Failed Upload!',
                    'Warning'
                );

                console.log(res.data.message);
            }

        }).catch((err) => {

            Swal.fire(
                'Failed!',
                'Failed Upload!',
                'Warning'
            );

            console.log(err);

        })

        event.preventDefault();
    }

    const getPromoDetail = () => {

        const token = localStorage.getItem("access_token");

        axiosInstance.post('v2/get_promo_detail', {

            token: token,
            group: group.wbid,
            id: param.id

        }).then((res) => {

            const data = res.data.data.list;

            setListData(data);

            setState({

                ...state,

                group: res.data.data.additional_data.group,

                menu: refactorStructureData(res.data.data.additional_data.menu),

            });

        }).catch((err) => {

            console.log(err);

        })

    }

    useEffect(() => {

        getPromoDetail();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (

        <div>

            <div className="bg-light-blue-500 pt-7 pb-28 px-3 md:px-8 h-auto"></div>

            <div className="px-3 md:px-8 h-auto -mt-24">

                <div className="container mx-auto max-w-full">

                    <div className="grid grid-cols-1 px-4 mb-16">

                        <Card>

                            <CardHeader color="blueGray" contentPosition="left">

                                <div className='flex justify-between ' style={{ width: '900px' }}>

                                    <h2 className="text-white text-2xl">Edit Promo Baner</h2>

                                </div>

                            </CardHeader>

                            <CardBody>
                                <form onSubmit={submitHandle}>
                                    <div className="w-1/2">
                                        <Input
                                            variant="outlined"
                                            label="Outlined"
                                            placeholder="Title"
                                            defaultValue={listData.title}
                                            onChange={(event) => {

                                                setTitle(event.target.value);
                                            }}
                                        />
                                    </div>

                                    <br />
                                    <div className="w-1/2">
                                        <Textarea
                                            placeholder="Description"
                                            defaultValue={listData.description}
                                            onChange={(event) => {

                                                setDescription(event.target.value);
                                            }} />
                                    </div>

                                    <br />
                                    <div className='w-1/4 h-auto'>
                                        <img src={listData.image} alt='edited' />
                                    </div>
                                    <br />
                                    <div className='w-1/2'>
                                        <div className='mb-1 mt-8'>

                                            <label>

                                                New Image: *.jpg, *.png, *.webp are accepted, Size: 600x400 px.

                                            </label>


                                        </div>
                                        <Input
                                            type="file"
                                            color="lightBlue"
                                            size="regular"
                                            outline={true}
                                            placeholder="New Image"
                                            onChange={(event) => setFile(event.target.files[0])}
                                        />
                                    </div>

                                    <br />

                                    <Button
                                        className="mt-5"
                                    >
                                        {loading ? 'Loading...' : 'Save'}
                                    </Button>
                                </form>

                            </CardBody>

                        </Card>

                    </div>

                </div >

            </div >

        </div >

    )

}

export default EditPromo;